/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 13:19:34
 * @LastEditors: duyuanyuan
 * @LastEditTime: 2023-09-28 15:57:01
 * @FilePath: \panda-index-sicermem-frontend\src\locales\en-US\aboutus.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'Componey.index.172950-0': 'National Invention Award',
  'Componey.index.172950-1': 'term',
  'Componey.index.172950-2': 'State Science and Technology Awards',
  'Componey.index.172950-3': 'Provincial and ministerial level scientific and technological progress award',
  'Componey.index.172950-4': 'Provincial Major Energy Conservation Achievement Award',
  'Componey.index.172950-5': 'Main honors',
  'Componey.index.172950-6': 'Technical experts and R&D team',
  'Componey.index.172950-7': 'Company Quality Policy',
  'Componey.index.172950-8':
    'Striving for excellence, continuous improvement, excellent quality, and satisfying customers',
  'Componey.index.172950-9':
    'The company always regards meeting customer needs as the first standard, and establishes and improves product quality systems with high standards. In 2003, it passed the ISO9001 quality system certification of the China Quality Certification Center (CQC), and in 2012, it passed the ISO9001:2008 standard system certification.',

  'Purpose.index.534003-0': 'Manufacturers of high-performance ceramic membranes',
  'Purpose.index.534003-1': 'Suitable production plants for ceramic membranes',
  'Purpose.index.534003-2': 'Trusted Partner in the Membrane Industry',
  'Purpose.index.534003-3': 'Corporate Purpose',

  'Qualifications.index.609371-4': 'Enterprise Qualification',

  'TestCenter.index.690467-0': 'Testing Center of SICERMEM',
  'TestCenter.index.690467-1':
    "Carry out inspection and testing technical services for chemical composition analysis, microstructure analysis, physical performance testing, etc. of ceramic materials, and provide professional data detection, collection, and analysis services for the research and development, product quality control, standardized production management, and other aspects of the company's inorganic non-metallic industry.",

  'AboutUs.index.745708-0': 'Enjoy special allowances from the State Council',
  'AboutUs.index.745708-1': 'Person time',
  'AboutUs.index.745708-2': 'National level young and middle-aged experts with outstanding contributions',
  'AboutUs.index.745708-3': 'people',
  'AboutUs.index.745708-4': 'Provincial and municipal (department) level top technical talents',
  'AboutUs.index.745708-5': 'About SICERMEM',
  'AboutUs.index.745708-6':
    'Shanghai SICERMEM Technology Co. Ltd. stems from Shandong institute of ceramic research & design which was founded in 1958, and was recognized as a national high-tech enterprise by Shanghai Science and Technology Commission in 2020.',
  'AboutUs.index.745708-7':
    'Morethan 60 years, SICERMEM has developed a series of products including W inorganic membranes,common flat ceramic membranes etc. So far SICERMEM has a great influence on inorganic membrane R&D both in China and overseas.',
  'AboutUs.index.745708-8':
    'Through cooperation with famous universities and research institutions at home and abroad such as Aalborg University and Tongji University, as well as large water groups, Shanghai SICERMEM has comprehensively improved the core technology of ceramic membrane, achieved sustainable development, and can provide customized inorganic membrane products for partners.',
  'AboutUs.index.745708-9': 'Technical experts and R&D team',
  'AboutUs.index.745708-10': 'en/aboutus',
  'AboutUs.index.745708-11': '/en/aboutus/introduce',
  'AboutUs.index.745708-12': '/en/aboutus/componey',
  'AboutUs.index.745708-13': '/en/aboutus/testCenter',
  'AboutUs.index.745708-14': '/en/aboutus/purpose',
  'AboutUs.index.745708-15': '/en/aboutus/qualifications',
};
